import type React from 'react';







/**



 * The command palette: search, navigate, ask and act from one keystroke.



 *



 * Pure ranking over three sources — the app's destinations, the vendor's



 * products, and the assistant — so the component is only a box and a list.



 * The rules are simple and stated here rather than learned: a destination



 * whose name starts with the query beats one that merely contains it;



 * products come after destinations; asking the assistant is always the last



 * row, so a query that matches nothing still does something.



 */







export interface Destination {



    route: string;



    /** Shown in the palette; the sidebar has its own. */



    icon?: React.ComponentType<{ className?: string }>;



    /** i18n key of the label. */



    labelKey: string;



    /** Extra words the vendor might type for it, in English; labels are matched in their language too. */



    keywords: string[];



    /** Which sidebar section it lives in, for the group header. */



    sectionKey: string;



}







export const DESTINATIONS: readonly Destination[] = [



    { route: '/home/dashboard', labelKey: 'AGENTS.NAV.HOME', keywords: ['today', 'home', 'dashboard', 'ask', 'agents'], sectionKey: 'AGENTS.NAV.SECTION' },
    { route: '/home/chat', labelKey: 'AGENTS.NAV.CONVERSATIONS', keywords: ['chat', 'conversation', 'ask', 'assistant', 'ai', 'agent'], sectionKey: 'AGENTS.NAV.SECTION' },
    { route: '/home/agents', labelKey: 'AGENTS.NAV.AGENTS', keywords: ['agents', 'team', 'ai', 'activity', 'runs', 'work', 'watch'], sectionKey: 'AGENTS.NAV.SECTION' },
    { route: '/home/overview', labelKey: 'AGENTS.NAV.OVERVIEW', keywords: ['overview', 'charts', 'widgets', 'map', 'figures', 'classic'], sectionKey: 'AGENTS.NAV.SECTION' },



    { route: '/products/catalog', labelKey: 'SIDEBAR.PRODUCTS.CATALOG', keywords: ['catalog', 'catalogue', 'products'], sectionKey: 'SIDEBAR.PRODUCTS.TITLE' },



    { route: '/products/new', labelKey: 'SIDEBAR.PRODUCTS.NEW_PRODUCT', keywords: ['new product', 'add product', 'create'], sectionKey: 'SIDEBAR.PRODUCTS.TITLE' },



    { route: '/products/import', labelKey: 'SIDEBAR.PRODUCTS.IMPORT_PRODUCTS', keywords: ['import', 'csv', 'upload'], sectionKey: 'SIDEBAR.PRODUCTS.TITLE' },



    { route: '/visualizer/engagement/leads', labelKey: 'SIDEBAR.ENGAGEMENT.LEADS', keywords: ['leads', 'customers', 'contacts'], sectionKey: 'SIDEBAR.ENGAGEMENT.TITLE' },





    { route: '/visualizer/engagement/analytics', labelKey: 'SIDEBAR.ENGAGEMENT.ANALYTICS', keywords: ['analytics', 'numbers', 'stats', 'visits'], sectionKey: 'SIDEBAR.ENGAGEMENT.TITLE' },



    { route: '/visualizer/engagement/activity', labelKey: 'SIDEBAR.ENGAGEMENT.TIMELINE', keywords: ['timeline', 'activity', 'events'], sectionKey: 'SIDEBAR.ENGAGEMENT.TITLE' },



    { route: '/marketing/brand', labelKey: 'SIDEBAR.MARKETING.BRAND', keywords: ['brand', 'business', 'profile', 'website', 'competitors'], sectionKey: 'SIDEBAR.MARKETING.TITLE' },



    { route: '/marketing/content-studio', labelKey: 'SIDEBAR.MARKETING.CONTENT_STUDIO', keywords: ['content studio', 'images', 'generate', 'canvas'], sectionKey: 'SIDEBAR.MARKETING.TITLE' },



    { route: '/marketing/email/compose', labelKey: 'SIDEBAR.MARKETING.EMAIL_MARKETING', keywords: ['email', 'campaign', 'newsletter'], sectionKey: 'SIDEBAR.MARKETING.TITLE' },



    { route: '/marketing/social-scheduler', labelKey: 'SIDEBAR.MARKETING.PLANNER', keywords: ['scheduler', 'social', 'posts', 'calendar', 'instagram', 'facebook'], sectionKey: 'SIDEBAR.MARKETING.TITLE' },



    { route: '/marketing/social-scheduler?tab=accounts', labelKey: 'SIDEBAR.MARKETING.SS_ACCOUNTS', keywords: ['accounts', 'connect instagram', 'connect facebook'], sectionKey: 'SIDEBAR.MARKETING.TITLE' },



    { route: '/spaces/my-selection', labelKey: 'SIDEBAR.VISUALIZER.MY_SELECTION', keywords: ['spaces', 'rooms', 'visualizer'], sectionKey: 'SIDEBAR.VISUALIZER.TITLE' },



    { route: '/visualizer/settings', labelKey: 'SIDEBAR.VISUALIZER.PARAMETERS', keywords: ['settings', 'configuration', 'design', 'colors', 'fonts'], sectionKey: 'SIDEBAR.VISUALIZER.TITLE' },



    { route: '/home/integration', labelKey: 'SIDEBAR.HOME.WEBSITE', keywords: ['integration', 'embed', 'snippet', 'website', 'domain', 'install'], sectionKey: 'WORKSPACE.HOME' },
    { route: '/visualizer/settings?tab=features', labelKey: 'SIDEBAR.CUSTOMIZATION.INTEGRATION', keywords: ['visualizer button', 'matching', 'sku', 'features', 'ar', '3d'], sectionKey: 'SIDEBAR.VISUALIZER.TITLE' },



    { route: '/home/billing/plan', labelKey: 'SIDEBAR.PLAN_BILLING', keywords: ['plan', 'billing', 'subscription', 'invoices', 'credits'], sectionKey: 'SIDEBAR.PLAN_BILLING' },
    { route: '/home/team', labelKey: 'VENDOR_TEAM.NAV', keywords: ['team', 'users', 'members', 'invite', 'colleague', 'access', 'people'], sectionKey: 'SIDEBAR.ACCOUNT.TITLE' },
    { route: '/home/devices', labelKey: 'SEATS.NAV', keywords: ['devices', 'seats', 'sessions', 'sign out', 'logged in', 'security'], sectionKey: 'SIDEBAR.ACCOUNT.TITLE' },

    // Only a query string: the chat opens over the current page.
    { route: '?support=new', labelKey: 'SUPPORT.PALETTE.CONTACT', keywords: ['support', 'help', 'contact', 'bug', 'problem', 'issue', 'feature request', 'chat'], sectionKey: 'SIDEBAR.ACCOUNT.TITLE' },



];







export interface PaletteProduct {



    uuid: string;



    name: string;



    sku?: string;



}







export type Command =



    | { kind: 'go'; key: string; route: string; label: string; section: string; score: number }



    | { kind: 'product'; key: string; route: string; label: string; sku?: string; score: number }



    | { kind: 'ask'; key: string; query: string; score: number };







const MAX_DESTINATIONS = 6;



const MAX_PRODUCTS = 5;







/** Where a product opens. */



export const productRoute = (uuid: string): string => `/products/${encodeURIComponent(uuid)}/edit`;







const norm = (s: string): string => s.normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();







/** 0 = no match; higher is better. Prefix beats word-start beats substring. */



export function matchScore(query: string, ...candidates: Array<string | undefined>): number {



    const q = norm(query);



    if (!q) return 1;



    let best = 0;



    for (const c of candidates) {



        if (!c) continue;



        const v = norm(c);



        if (v === q) best = Math.max(best, 100);



        else if (v.startsWith(q)) best = Math.max(best, 80);



        else if (v.split(/\s+/).some((w) => w.startsWith(q))) best = Math.max(best, 60);



        else if (v.includes(q)) best = Math.max(best, 40);



    }



    return best;



}







export function rankCommands(



    query: string,



    products: readonly PaletteProduct[],



    t: (key: string) => string,



): Command[] {



    const q = query.trim();







    const go: Command[] = DESTINATIONS.map((d) => {



        const label = t(d.labelKey);



        return { kind: 'go' as const, key: `go:${d.route}`, route: d.route, label, section: t(d.sectionKey), score: matchScore(q, label, ...d.keywords) };



    })



        .filter((c) => c.score > 0)



        .sort((a, b) => b.score - a.score)



        .slice(0, MAX_DESTINATIONS);







    // Products only once something is typed: a blank palette is for going places.



    const hits: Command[] = q



        ? products



            .map((p) => ({ kind: 'product' as const, key: `product:${p.uuid}`, route: productRoute(p.uuid), label: p.name, sku: p.sku, score: matchScore(q, p.name, p.sku) }))



            .filter((c) => c.score > 0)



            .sort((a, b) => b.score - a.score || a.label.localeCompare(b.label))



            .slice(0, MAX_PRODUCTS)



        : [];







    const ask: Command[] = q ? [{ kind: 'ask', key: 'ask', query: q, score: 0 }] : [];







    return [...go, ...hits, ...ask];



}
